import { Navigate } from 'react-router-dom';

export default function SecurityRecommendations() {
  return <Navigate to="/secure-score?tab=recs" replace />;
}
